import {BaseDomainService} from "../../../../../infrastructure/domain-services/base-domain-service";
import {FetchHandler} from "../../../../../infrastructure/handlers/fetch-handler";
import {BettingPromotionModuleState} from "../models/betting-promotion.module.state";
import {LocalStorageUtils} from "../../../../../infrastructure/utils/local-storage.utils";
import {BaseController} from "../../../../../infrastructure/controllers/base-controller";
import {CookieManager} from "../../../../../core/managers/cookie-manager";

export class BettingPromotionModuleFetchHandler extends FetchHandler {
  state: BettingPromotionModuleState;
  localStorageUtils: LocalStorageUtils;
  cookieManager: CookieManager;

  static injectables = [BaseDomainService, LocalStorageUtils, CookieManager];

  constructor(service: BaseDomainService, localStorageUtils: LocalStorageUtils, cookieManager: CookieManager) {
    super(service);

    this.localStorageUtils = localStorageUtils;
    this.cookieManager = cookieManager;
  }

  onInitialized(controller: BaseController) {
    super.onInitialized(controller);

    this.state.popupVisibleCounter = this.appStore.state.appBettingPromotionDisplayModel.localStorageModel.visibleCounter;
    this.state.generatedGUID = this.makeid(32);
    this.state.ga4ClientId = this.cookieManager.ga4ClientId;
    this.state.ga4SessionId = this.cookieManager.ga4SessionId;
  }

  makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
